import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { SplitLayout } from '../layouts/SplitLayout';
import { TemplateSection } from './Section';

export type HowToTemplateProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  lede?: ReactNode;
  /** Steps: a real sequence, so numbered. */
  steps: ReactNode;
  faq?: { title: ReactNode; content: ReactNode };
  /** A TableOfContents of the steps, with the page's one primary action in its action slot. */
  stepsNav?: ReactNode;
  className?: string;
};

/** Step-by-step guides (job-search/*, tyonhaku/*, jobbsok/*): numbered steps, an FAQ, and sticky steps navigation. */
export function HowToTemplate({ eyebrow, title, lede, steps, faq, stepsNav, className }: HowToTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-block py-jc-section">
        <header className="flex max-w-3xl flex-col gap-3">
          {eyebrow ? <span className="type-eyebrow text-jc-ink-secondary">{eyebrow}</span> : null}
          <h1 className="type-display text-jc-ink">{title}</h1>
          {lede ? <p className="text-base text-jc-ink-secondary">{lede}</p> : null}
        </header>
        <SplitLayout aside={stepsNav} asidePosition="right" asideWidth="toc" stickyAside>
          <div className="flex flex-col gap-jc-section">
            {steps}
            {faq ? (
              <TemplateSection id="faq" title={faq.title}>
                {faq.content}
              </TemplateSection>
            ) : null}
          </div>
        </SplitLayout>
      </div>
    </PageContainer>
  );
}
